export const DEFAULT_INVOICE_BOLD_FIELDS = [
  'InvoiceDate',
  'InvoiceRef',
  'TotalWithTax',
  'BillableDescription',
  'MatterId',
  'BillableTotal',
  'NonBillableDescription',
  'GLNatural',
  'NonBillableTotal',
  'LineComments',
];

export const INVOICE_BOLD_FIELD_OPTIONS = [
  { id: 'Status', labelKey: 'invoice.status_txt', fallbackLabel: 'Status' },
  { id: 'Workflow', labelKey: 'workflow', fallbackLabel: 'Workflow' },
  { id: 'SupplierName', labelKey: 'invoice.supplier_name', fallbackLabel: 'Supplier Name' },
  { id: 'SupplierNumber', labelKey: 'invoice.supplier_number', fallbackLabel: 'Supplier Number' },
  { id: 'APType', labelKey: 'invoice.ap_type', fallbackLabel: 'AP Type' },
  { id: 'InvoiceJurisdiction', labelKey: 'roles.invoice_field_invoice_jurisdiction', fallbackLabel: 'Jurisdiction — Invoice header' },
  { id: 'InvoiceHoldDate', labelKey: 'roles.invoice_field_invoice_hold_date', fallbackLabel: 'Hold date — Invoice header' },
  { id: 'DiscountDate', labelKey: 'invoice.discount_date', fallbackLabel: 'Discount Date' },
  { id: 'InvoiceDate', labelKey: 'invoice.billing_date', fallbackLabel: 'Invoice Date' },
  { id: 'PaymentTerm', labelKey: 'invoice.payment_terms', fallbackLabel: 'Payment Terms' },
  { id: 'DueDate', labelKey: 'invoice.pay_date', fallbackLabel: 'Pay Date' },
  { id: 'TranDate', labelKey: 'invoice.transaction_date', fallbackLabel: 'Transaction Date' },
  { id: 'InvoiceAttorney', labelKey: 'roles.invoice_field_invoice_attorney', fallbackLabel: 'Attorney — Invoice header' },
  { id: 'InvoiceNo', labelKey: 'invoice.invoice_number', fallbackLabel: 'Invoice Number' },
  { id: 'InvoiceRef', labelKey: 'invoice.invoice_ref', fallbackLabel: 'Cheque Reference' },
  { id: 'Currency', labelKey: 'invoice.currency', fallbackLabel: 'Currency' },
  { id: 'GroupNumber', labelKey: 'invoice.group_number', fallbackLabel: 'Group Number' },
  { id: 'DiscountAmount', labelKey: 'invoice.discount_amount', fallbackLabel: 'Discount Amount' },
  { id: 'Total', labelKey: 'invoice.total', fallbackLabel: 'Total' },
  { id: 'TotalWithTax', labelKey: 'invoice.total_with_tax', fallbackLabel: 'Grand Total' },
  { id: 'GLUnit', labelKey: 'roles.invoice_field_gl_unit', fallbackLabel: 'Unit — Invoice header' },
  { id: 'InvoiceOffice', labelKey: 'roles.invoice_field_invoice_office', fallbackLabel: 'Office — Invoice header' },
  { id: 'InvoiceGLDepartement', labelKey: 'roles.invoice_field_invoice_gl_departement', fallbackLabel: 'GL Department — Invoice header' },
  { id: 'InvoiceGLSection', labelKey: 'roles.invoice_field_invoice_gl_section', fallbackLabel: 'GL Section — Invoice header' },
  { id: 'InvoiceType', labelKey: 'roles.invoice_field_invoice_type', fallbackLabel: 'Type — Invoice header' },
  { id: 'Approver', labelKey: 'invoice.approver', fallbackLabel: 'Approver' },
  { id: 'PurchaseAndPayment', labelKey: 'achat_and_payment', fallbackLabel: 'Purchase and Payment' },
  { id: 'PaymentMode', labelKey: 'payment_mode', fallbackLabel: 'Payment Mode' },
  { id: 'PaymentBank', labelKey: 'card', fallbackLabel: 'Card' },
  { id: 'PayeeCategory', labelKey: 'invoice.payee_category', fallbackLabel: 'Payee Category' },
  { id: 'SupplierAddress', labelKey: 'invoice.supplier_address', fallbackLabel: 'Supplier Address' },
  { id: 'BillableDescription', labelKey: 'roles.invoice_field_billable_description', fallbackLabel: 'Description — Cost details' },
  { id: 'BillableOffice', labelKey: 'roles.invoice_field_billable_office', fallbackLabel: 'Office — Cost details' },
  { id: 'WorkDate', labelKey: 'invoice.work_date', fallbackLabel: 'Work Date' },
  { id: 'MatterId', labelKey: 'invoice.matter_id', fallbackLabel: 'Matter ID' },
  { id: 'LineAttorney', labelKey: 'roles.invoice_field_line_attorney', fallbackLabel: 'Attorney — Cost details' },
  { id: 'CostType', labelKey: 'roles.invoice_field_cost_type', fallbackLabel: 'Type — Cost details' },
  { id: 'BillableTaxCode', labelKey: 'roles.invoice_field_billable_tax_code', fallbackLabel: 'Tax code — Cost details' },
  { id: 'BillableTotal', labelKey: 'roles.invoice_field_billable_total', fallbackLabel: 'Amount — Cost details' },
  { id: 'NonBillableDescription', labelKey: 'roles.invoice_field_non_billable_description', fallbackLabel: 'Description — GL details' },
  { id: 'LineGLUnit', labelKey: 'roles.invoice_field_line_gl_unit', fallbackLabel: 'Unit — GL details' },
  { id: 'NonBillableOffice', labelKey: 'roles.invoice_field_non_billable_office', fallbackLabel: 'Office — GL details' },
  { id: 'GLNatural', labelKey: 'invoice.gl_nat', fallbackLabel: 'GL Natural' },
  { id: 'NonBillableTaxCode', labelKey: 'roles.invoice_field_non_billable_tax_code', fallbackLabel: 'Tax code — GL details' },
  { id: 'NonBillableTotal', labelKey: 'roles.invoice_field_non_billable_total', fallbackLabel: 'Amount — GL details' },
  { id: 'Tax1', labelKey: 'roles.invoice_field_tax1', fallbackLabel: 'Tax 1 — Invoice' },
  { id: 'Tax2', labelKey: 'roles.invoice_field_tax2', fallbackLabel: 'Tax 2 — Invoice' },
  { id: 'InvoiceComments', labelKey: 'roles.invoice_field_invoice_comments', fallbackLabel: 'Comments — Invoice' },
  { id: 'WorkQuantity', labelKey: 'invoice.work_quantity', fallbackLabel: 'Work Quantity' },
  { id: 'WorkRate', labelKey: 'invoice.work_rate', fallbackLabel: 'Work Rate' },
  { id: 'WorkTotal', labelKey: 'invoice.work_total', fallbackLabel: 'Work Total' },
  { id: 'LineOffice', labelKey: 'roles.invoice_field_line_office', fallbackLabel: 'Office — Additional fields' },
  { id: 'Department', labelKey: 'invoice.department', fallbackLabel: 'Department' },
  { id: 'LineGLDepartement', labelKey: 'roles.invoice_field_line_gl_departement', fallbackLabel: 'GL Department — Additional fields' },
  { id: 'LineGLSection', labelKey: 'roles.invoice_field_line_gl_section', fallbackLabel: 'GL Section — Additional fields' },
  { id: 'GLPracticeGroup', labelKey: 'invoice.gl_practice_group', fallbackLabel: 'GL Practice Group' },
  { id: 'Activity', labelKey: 'invoice.activity', fallbackLabel: 'Activity' },
  { id: 'Employee', labelKey: 'invoice.employee', fallbackLabel: 'Employee' },
  { id: 'IncurringEmployee', labelKey: 'invoice.incurring_employee', fallbackLabel: 'Incurring Employee' },
  { id: 'AuthorizingEmployee', labelKey: 'invoice.authorizing_employee', fallbackLabel: 'Authorizing Employee' },
  { id: 'ProfitCenter', labelKey: 'invoice.profit_center', fallbackLabel: 'Profit Center' },
  { id: 'LineJurisdiction', labelKey: 'roles.invoice_field_line_jurisdiction', fallbackLabel: 'Jurisdiction — Additional fields' },
  { id: 'LineHoldDate', labelKey: 'roles.invoice_field_line_hold_date', fallbackLabel: 'Hold date — Additional fields' },
  { id: 'Location', labelKey: 'invoice.location', fallbackLabel: 'Location' },
  { id: 'Project', labelKey: 'invoice.project', fallbackLabel: 'Project' },
  { id: 'Reference', labelKey: 'invoice.reference', fallbackLabel: 'Reference' },
  { id: 'CalculateAmountsAutomatically', labelKey: 'invoice.auto_calculation', fallbackLabel: 'Auto Calculation' },
  { id: 'ToBillAmount', labelKey: 'invoice.to_bill_amount', fallbackLabel: 'To-Bill Amount' },
  { id: 'PreBillDisbursementNarrative', labelKey: 'invoice.pre_bill_narrative', fallbackLabel: 'Pre-Bill Narrative' },
  { id: 'LineComments', labelKey: 'roles.invoice_field_line_comments', fallbackLabel: 'Comments — Additional fields' },
];

// Grand Total uses one invoice value in both places, but role visibility must address each row independently.
export const INVOICE_HIDDEN_FIELD_OPTIONS = INVOICE_BOLD_FIELD_OPTIONS.flatMap((field) => {
  if (field.id !== 'TotalWithTax') return [field];

  return [
    { id: 'TotalWithTaxTop', labelKey: 'roles.invoice_field_grand_total_top', fallbackLabel: 'Grand Total (top)' },
    { id: 'TotalWithTaxBottom', labelKey: 'roles.invoice_field_grand_total_bottom', fallbackLabel: 'Grand Total (bottom)' },
  ];
});

export const normalizeInvoiceBoldFields = (fieldIds) => (
  Array.isArray(fieldIds) && fieldIds.length > 0 ? fieldIds : []
);

export const resolveInvoiceBoldFields = (invoiceEditorConfig) => normalizeInvoiceBoldFields(invoiceEditorConfig?.bold_fields);

export const isInvoiceBoldField = (fieldIds, fieldId) => normalizeInvoiceBoldFields(fieldIds).includes(fieldId);

export const normalizeInvoiceHiddenFields = (fieldIds) => (
  Array.isArray(fieldIds) ? fieldIds : []
);

export const resolveInvoiceHiddenFields = (invoiceEditorConfig) => {
  const hiddenFields = normalizeInvoiceHiddenFields(invoiceEditorConfig?.hidden_fields);

  // Roles saved before XPEN-2954 used one identifier to hide both rows. Preserve that behavior until reconfigured.
  if (hiddenFields.includes('TotalWithTax')) {
    return Array.from(new Set([...hiddenFields, 'TotalWithTaxTop', 'TotalWithTaxBottom']));
  }

  return hiddenFields;
};

export const isInvoiceHiddenField = (fieldIds, fieldId) => normalizeInvoiceHiddenFields(fieldIds).includes(fieldId);
